var pluginVisited = false
export default function eventAttendeePluginVisit (eventAttendee, pluginData, Echo) {
  if (pluginVisited) return
  console.log('visiting plugin')
  if (eventAttendee && pluginData) {
    // Set channel params
    var eventId = eventAttendee.event_id
    var eventAttendeeId = eventAttendee.id
    var pluginType = pluginData.pluginType
    var pluginId = pluginData.pluginId
    var channelName = `event-attendee-plugin-visits.event.${eventId}.attendee.${eventAttendeeId}.${pluginType}.${pluginId}`
    Echo.private(channelName)
    pluginVisited = true
  }
}